import { ImageBlock } from '../molecules/ImageBlock';
import { TextBlock } from '../molecules/TextBlock';
import { getBackgroundColorClassName } from '../../../lib/getColorClassNames';
import { Title } from '../atoms/Title';
import { useDOMPurify } from '../../../lib/useDOMPurify';
import { SimpleReactComponentProps } from '../../../types/components';

export interface TextImageBlockProps extends SimpleReactComponentProps {
	text: {
		title: string;
		summary?: string;
		backgroundColor: string;
		fontColor: string;
	};
	image: {
		src: string;
		description?: string;
	};
	imagePosition?: string;
	className?: string;
}

export const TextAndImageBlock = ({
	text,
	image,
	imagePosition = 'Left',
	anchorId,
}: TextImageBlockProps) => {
	const reversed = imagePosition === 'Right';
	const { title, summary, backgroundColor } = text;
	const { src, description } = image;

	const contentContainerStyles = getBackgroundColorClassName(backgroundColor);
	const containerClassNames = `flex flex-col md:flex-row ${
		reversed ? 'md:flex-row-reverse' : ''
	} ${contentContainerStyles} gap-10 scroll-mt-[84px]`;

	const sanitizedSummary = useDOMPurify(summary || '');
	const defaultImageAlt = 'default img alt';

	return (
		<section className={containerClassNames} id={anchorId?.value}>
			{src && (
				<ImageBlock
					src={src}
					alt={description || defaultImageAlt}
					showCaption
					classOverrides="grow object-cover"
				/>
			)}
			<div className="flex-1">
				<Title style="H3" title={title} />
				{sanitizedSummary ? (
					<TextBlock content={sanitizedSummary} classOverrides="mt-4" />
				) : null}
			</div>
		</section>
	);
};
